/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ numberOfRecords: NonNullable<unknown> }} Swift_True_Robin_SingInputs */

const en_swift_true_robin_sing = /** @type {(inputs: Swift_True_Robin_SingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Acknowledge import (${i?.numberOfRecords} records)`)
};

const de_swift_true_robin_sing = /** @type {(inputs: Swift_True_Robin_SingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import bestätigen (${i?.numberOfRecords} Datensätze)`)
};

/**
* | output |
* | --- |
* | "Acknowledge import ({numberOfRecords} records)" |
*
* @param {Swift_True_Robin_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const swift_true_robin_sing = /** @type {((inputs: Swift_True_Robin_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_True_Robin_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_swift_true_robin_sing(inputs)
	return de_swift_true_robin_sing(inputs)
});